import {Card, ListGroup, ProgressBar} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {formatDate} from "../../../util/StringUtils";
import {getLadderSpan, getRatingColorVariant} from "../../../util/HelperUtils";
import type {PlayerResult} from "../../../types/domain";

interface TournamentResultCardProps {
  result: PlayerResult;
}

function TournamentResultCard(props: TournamentResultCardProps) {
  const { t, i18n } = useTranslation();
  const stats = props.result

    return (
      <Card className="tournament-result-card">
        <Card.Body>
          <Card.Title style={{color: "lightgreen"}}>
            <Link to={"/tournaments/" + stats.tournament.id} style={{ textDecoration: 'none', color: "lightgreen" }} >
              {stats.tournament.name}
            </Link>
          </Card.Title>
          <Card.Text>{formatDate(stats.createdAt)}</Card.Text>
        </Card.Body>
        <ListGroup className="list-group-flush">
          <ListGroup.Item>{t("ladder")}: {getLadderSpan(i18n, stats.tournament.ladder)}</ListGroup.Item>
          <ListGroup.Item>{t("placement")}: {stats.placement}. {t("outOf")} {stats.playerCount}</ListGroup.Item>
        </ListGroup>
        <div className="ms-2 me-2 mb-2">
          <div className="mt-2 mb-2" style={{textAlign: "center"}}>
            {t("matches")}
          </div>
          <ProgressBar max={200}>
            <ProgressBar label={stats.matchesWon} variant="success" now={stats.matchesWon} key={1} max={stats.matchesWon + stats.matchesLost} />
            <ProgressBar label={stats.matchesLost} variant="danger" now={stats.matchesLost} key={2} max={stats.matchesWon + stats.matchesLost} />
          </ProgressBar>
          <div className="mt-2 mb-2" style={{textAlign: "center"}}>
            {t("sets")}
          </div>
          <ProgressBar max={200}>
            <ProgressBar label={stats.setsWon} variant="success" now={stats.setsWon} key={1} max={stats.setsWon + stats.setsLost} />
            <ProgressBar label={stats.setsLost} variant="danger" now={stats.setsLost} key={2} max={stats.setsWon + stats.setsLost} />
          </ProgressBar>
          <div className="mt-2 mb-2" style={{textAlign: "center"}}>
            {t("points")}
          </div>
          <ProgressBar max={200}>
            <ProgressBar label={stats.pointsWon} variant="success" now={stats.pointsWon} key={1} max={stats.pointsWon + stats.pointsLost} />
            <ProgressBar label={stats.pointsLost} variant="danger" now={stats.pointsLost} key={2} max={stats.pointsWon + stats.pointsLost} />
          </ProgressBar>
          <div className="mt-2 mb-2" style={{textAlign: "center"}}>
            Rating
          </div>
          <ProgressBar label={stats.averageRating.toFixed(2)} now={stats.averageRating} max={2.0} min={-0.1}
                       variant={getRatingColorVariant(stats.averageRating, true)} animated={stats.averageRating > 2.0} />
        </div>
      </Card>
    );
}

export default TournamentResultCard
